import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterRangeBoxHandler from "./IDataFilterRangeBoxHandler";
import IDataFilterRangeValue from "./IDataFilterRangeValue";

export default class DataFilterRangeBoxHandler
  implements IDataFilterRangeBoxHandler {
  setDescriptorValuesFromUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    const storeMin = urlParams.get(`${descriptor.name}From`);
    const storeMax = urlParams.get(`${descriptor.name}To`);

    (descriptor.value as IDataFilterRangeValue).value = [
      storeMin
        ? Number.parseInt(storeMin)
        : (descriptor.value as IDataFilterRangeValue).min,
      storeMax
        ? Number.parseInt(storeMax)
        : (descriptor.value as IDataFilterRangeValue).max,
    ];
  }

  setDescriptorValuesToUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    const rangeValue = descriptor.value as IDataFilterRangeValue;

    if (rangeValue.min !== rangeValue.value[0]) {
      urlParams.set(`${descriptor.name}From`, rangeValue.value[0].toString());
    } else {
      urlParams.delete(`${descriptor.name}From`);
    }

    if (rangeValue.max !== rangeValue.value[1]) {
      urlParams.set(`${descriptor.name}To`, rangeValue.value[1].toString());
    } else {
      urlParams.delete(`${descriptor.name}To`);
    }
  }
}
